<template>
  <v-app-bar
    app
    clipped-left
    height="72px"
    class="app-bar"
  >
    <!-- ハンバーガーアイコン -->
    <v-menu-icon/>

    <!-- 使い方動画一覧(新学社HP)へのリンク -->
    <v-manual-video-link/>

    <!-- ロゴ画像 -->
    <p class="header-logo">
      <router-link :to="homePath">
        <img src="@/assets/img/header_logo.png" alt="新学社">
      </router-link>
    </p>

  </v-app-bar>
</template>


<script>
import VMenuIcon from '@/components/atoms/MenuIcon'
import VManualVideoLink from '@/components/atoms/ManualVideoLink'
export default {
  components: {
    VMenuIcon,
    VManualVideoLink
  },

  computed: {
    homePath() {
      return this.$store.getters['user/homePath']
    }
  },
}
</script>
